// This file is auto-generated by @hey-api/openapi-ts

import { z } from 'zod';

import type { Client, ClientMeta, Options as Options2, RequestResult, TDataShape } from './client';
import { client } from './client.gen';
import type { BenefitPlansCreateBenefitPlanGroupData, BenefitPlansCreateBenefitPlanGroupErrors, BenefitPlansCreateBenefitPlanGroupResponses, BenefitPlansDeleteBenefitPlanGroupData, BenefitPlansDeleteBenefitPlanGroupErrors, BenefitPlansDeleteBenefitPlanGroupResponses, BenefitPlansGetBenefitPlanGroupData, BenefitPlansGetBenefitPlanGroupErrors, BenefitPlansGetBenefitPlanGroupPremiumsData, BenefitPlansGetBenefitPlanGroupPremiumsErrors, BenefitPlansGetBenefitPlanGroupPremiumsResponses, BenefitPlansGetBenefitPlanGroupResponses, BenefitPlansListBenefitPlanGroupsData, BenefitPlansListBenefitPlanGroupsErrors, BenefitPlansListBenefitPlanGroupsResponses, BenefitPlansReorderBenefitPlanGroupsData, BenefitPlansReorderBenefitPlanGroupsErrors, BenefitPlansReorderBenefitPlanGroupsResponses, BenefitPlansUpdateBenefitPlanData, BenefitPlansUpdateBenefitPlanErrors, BenefitPlansUpdateBenefitPlanGroupData, BenefitPlansUpdateBenefitPlanGroupErrors, BenefitPlansUpdateBenefitPlanGroupResponses, BenefitPlansUpdateBenefitPlanResponses, BenefitPlansUpsertBenefitPlanData, BenefitPlansUpsertBenefitPlanErrors, BenefitPlansUpsertBenefitPlanResponses, ProposalsAddProposalPlanToGroupData, ProposalsAddProposalPlanToGroupErrors, ProposalsAddProposalPlanToGroupResponses, ProposalsCreateProposalForRfpData, ProposalsCreateProposalForRfpErrors, ProposalsCreateProposalForRfpResponses, ProposalsDeleteProposalCommissionData, ProposalsDeleteProposalCommissionErrors, ProposalsDeleteProposalCommissionResponses, ProposalsDeleteProposalPlanData, ProposalsDeleteProposalPlanErrors, ProposalsDeleteProposalPlanGroupData, ProposalsDeleteProposalPlanGroupErrors, ProposalsDeleteProposalPlanGroupResponses, ProposalsDeleteProposalPlanResponses, ProposalsDisregardProposalPlanGroupData, ProposalsDisregardProposalPlanGroupErrors, ProposalsDisregardProposalPlanGroupResponses, ProposalsGetProposalData, ProposalsGetProposalErrors, ProposalsGetProposalResponses, ProposalsListProposalsForRfpData, ProposalsListProposalsForRfpErrors, ProposalsListProposalsForRfpResponses, ProposalsPromoteProposalPlanGroupData, ProposalsPromoteProposalPlanGroupErrors, ProposalsPromoteProposalPlanGroupResponses, ProposalsReplaceProposalPlanGroupData, ProposalsReplaceProposalPlanGroupErrors, ProposalsReplaceProposalPlanGroupResponses, ProposalsRestoreProposalPlanData, ProposalsRestoreProposalPlanErrors, ProposalsRestoreProposalPlanGroupData, ProposalsRestoreProposalPlanGroupErrors, ProposalsRestoreProposalPlanGroupResponses, ProposalsRestoreProposalPlanResponses, ProposalsUpdateProposalCommissionData, ProposalsUpdateProposalCommissionErrors, ProposalsUpdateProposalCommissionResponses, ProposalsUpdateProposalPlanBenefitsData, ProposalsUpdateProposalPlanBenefitsErrors, ProposalsUpdateProposalPlanBenefitsResponses, ProposalsUpdateProposalPlanFieldsData, ProposalsUpdateProposalPlanFieldsErrors, ProposalsUpdateProposalPlanFieldsResponses, ProposalsUpdateProposalPlanGroupFieldsData, ProposalsUpdateProposalPlanGroupFieldsErrors, ProposalsUpdateProposalPlanGroupFieldsResponses, RfpsExportRfpPayloadData, RfpsExportRfpPayloadErrors, RfpsExportRfpPayloadResponses, RfpsGetRfpData, RfpsGetRfpErrors, RfpsGetRfpResponses, RfpsListCarrierNoteExistenceData, RfpsListCarrierNoteExistenceErrors, RfpsListCarrierNoteExistenceResponses, RfpsSetCoverageCompletionData, RfpsSetCoverageCompletionErrors, RfpsSetCoverageCompletionResponses, RfpsUpsertFieldCommentsData, RfpsUpsertFieldCommentsErrors, RfpsUpsertFieldCommentsResponses } from './types.gen';
import { zBenefitPlansCreateBenefitPlanGroupBody, zBenefitPlansCreateBenefitPlanGroupHeaders, zBenefitPlansCreateBenefitPlanGroupResponse, zBenefitPlansDeleteBenefitPlanGroupPath, zBenefitPlansDeleteBenefitPlanGroupResponse, zBenefitPlansGetBenefitPlanGroupHeaders, zBenefitPlansGetBenefitPlanGroupPath, zBenefitPlansGetBenefitPlanGroupPremiumsPath, zBenefitPlansGetBenefitPlanGroupPremiumsResponse, zBenefitPlansGetBenefitPlanGroupResponse, zBenefitPlansListBenefitPlanGroupsHeaders, zBenefitPlansListBenefitPlanGroupsQuery, zBenefitPlansListBenefitPlanGroupsResponse, zBenefitPlansReorderBenefitPlanGroupsBody, zBenefitPlansReorderBenefitPlanGroupsQuery, zBenefitPlansReorderBenefitPlanGroupsResponse, zBenefitPlansUpdateBenefitPlanBody, zBenefitPlansUpdateBenefitPlanGroupBody, zBenefitPlansUpdateBenefitPlanGroupHeaders, zBenefitPlansUpdateBenefitPlanGroupPath, zBenefitPlansUpdateBenefitPlanGroupResponse, zBenefitPlansUpdateBenefitPlanHeaders, zBenefitPlansUpdateBenefitPlanPath, zBenefitPlansUpdateBenefitPlanResponse, zBenefitPlansUpsertBenefitPlanBody, zBenefitPlansUpsertBenefitPlanPath, zBenefitPlansUpsertBenefitPlanResponse, zProposalsAddProposalPlanToGroupBody, zProposalsAddProposalPlanToGroupPath, zProposalsAddProposalPlanToGroupResponse, zProposalsCreateProposalForRfpBody, zProposalsCreateProposalForRfpHeaders, zProposalsCreateProposalForRfpPath, zProposalsCreateProposalForRfpResponse, zProposalsDeleteProposalCommissionPath, zProposalsDeleteProposalCommissionResponse, zProposalsDeleteProposalPlanGroupPath, zProposalsDeleteProposalPlanGroupResponse, zProposalsDeleteProposalPlanPath, zProposalsDeleteProposalPlanResponse, zProposalsDisregardProposalPlanGroupHeaders, zProposalsDisregardProposalPlanGroupPath, zProposalsDisregardProposalPlanGroupResponse, zProposalsGetProposalHeaders, zProposalsGetProposalPath, zProposalsGetProposalResponse, zProposalsListProposalsForRfpHeaders, zProposalsListProposalsForRfpPath, zProposalsListProposalsForRfpQuery, zProposalsListProposalsForRfpResponse, zProposalsPromoteProposalPlanGroupHeaders, zProposalsPromoteProposalPlanGroupPath, zProposalsPromoteProposalPlanGroupResponse, zProposalsReplaceProposalPlanGroupHeaders, zProposalsReplaceProposalPlanGroupPath, zProposalsReplaceProposalPlanGroupResponse, zProposalsRestoreProposalPlanGroupHeaders, zProposalsRestoreProposalPlanGroupPath, zProposalsRestoreProposalPlanGroupResponse, zProposalsRestoreProposalPlanPath, zProposalsRestoreProposalPlanResponse, zProposalsUpdateProposalCommissionBody, zProposalsUpdateProposalCommissionPath, zProposalsUpdateProposalCommissionResponse, zProposalsUpdateProposalPlanBenefitsBody, zProposalsUpdateProposalPlanBenefitsPath, zProposalsUpdateProposalPlanBenefitsResponse, zProposalsUpdateProposalPlanFieldsBody, zProposalsUpdateProposalPlanFieldsPath, zProposalsUpdateProposalPlanFieldsResponse, zProposalsUpdateProposalPlanGroupFieldsBody, zProposalsUpdateProposalPlanGroupFieldsPath, zProposalsUpdateProposalPlanGroupFieldsResponse, zRfpsExportRfpPayloadPath, zRfpsExportRfpPayloadResponse, zRfpsGetRfpHeaders, zRfpsGetRfpPath, zRfpsGetRfpResponse, zRfpsListCarrierNoteExistencePath, zRfpsListCarrierNoteExistenceResponse, zRfpsSetCoverageCompletionBody, zRfpsSetCoverageCompletionPath, zRfpsSetCoverageCompletionQuery, zRfpsSetCoverageCompletionResponse, zRfpsUpsertFieldCommentsBody, zRfpsUpsertFieldCommentsPath, zRfpsUpsertFieldCommentsResponse2 } from './zod.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

/**
 * List benefit plan groups
 *
 * Returns all benefit plan groups for the given RFP and coverage type,
 * ordered by position. Optionally filter by product type.
 *
 */
export const benefitPlansListBenefitPlanGroups = <ThrowOnError extends boolean = false>(options: Options<BenefitPlansListBenefitPlanGroupsData, ThrowOnError>): RequestResult<BenefitPlansListBenefitPlanGroupsResponses, BenefitPlansListBenefitPlanGroupsErrors, ThrowOnError> => (options.client ?? client).get<BenefitPlansListBenefitPlanGroupsResponses, BenefitPlansListBenefitPlanGroupsErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        headers: zBenefitPlansListBenefitPlanGroupsHeaders.optional(),
        path: z.never().optional(),
        query: zBenefitPlansListBenefitPlanGroupsQuery
    }).parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) => await zBenefitPlansListBenefitPlanGroupsResponse.parseAsync(data),
    url: '/benefit-plan-groups',
    ...options
});

/**
 * Create a benefit plan group
 *
 * Creates a new benefit plan group in one of two modes:
 *
 * **From scratch** — provide `rfpId` + `coverageType` and a
 * `benefitPlanGroup` object with the desired product type, policy
 * period, and size. Empty plan shells are generated automatically.
 *
 * **Clone from existing** — provide `referenceGroupId` to copy all
 * plan data (carrier names, rates, funding types, benefits) from an
 * existing group. Product type and size are inherited; policy period
 * and nickname can be overridden.
 *
 * Only one mode may be specified per request.
 *
 */
export const benefitPlansCreateBenefitPlanGroup = <ThrowOnError extends boolean = false>(options: Options<BenefitPlansCreateBenefitPlanGroupData, ThrowOnError>): RequestResult<BenefitPlansCreateBenefitPlanGroupResponses, BenefitPlansCreateBenefitPlanGroupErrors, ThrowOnError> => (options.client ?? client).post<BenefitPlansCreateBenefitPlanGroupResponses, BenefitPlansCreateBenefitPlanGroupErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: zBenefitPlansCreateBenefitPlanGroupBody,
        headers: zBenefitPlansCreateBenefitPlanGroupHeaders.optional(),
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) => await zBenefitPlansCreateBenefitPlanGroupResponse.parseAsync(data),
    url: '/benefit-plan-groups',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a benefit plan group
 *
 * Deletes a benefit plan group and its plans. At least one group with the
 * required primary policy period must remain after deletion.
 *
 */
export const benefitPlansDeleteBenefitPlanGroup = <ThrowOnError extends boolean = false>(options: Options<BenefitPlansDeleteBenefitPlanGroupData, ThrowOnError>): RequestResult<BenefitPlansDeleteBenefitPlanGroupResponses, BenefitPlansDeleteBenefitPlanGroupErrors, ThrowOnError> => (options.client ?? client).delete<BenefitPlansDeleteBenefitPlanGroupResponses, BenefitPlansDeleteBenefitPlanGroupErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zBenefitPlansDeleteBenefitPlanGroupPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zBenefitPlansDeleteBenefitPlanGroupResponse.parseAsync(data),
    url: '/benefit-plan-groups/{id}',
    ...options
});

/**
 * Get a benefit plan group
 *
 * Returns a single benefit plan group with all nested benefit plans.
 */
export const benefitPlansGetBenefitPlanGroup = <ThrowOnError extends boolean = false>(options: Options<BenefitPlansGetBenefitPlanGroupData, ThrowOnError>): RequestResult<BenefitPlansGetBenefitPlanGroupResponses, BenefitPlansGetBenefitPlanGroupErrors, ThrowOnError> => (options.client ?? client).get<BenefitPlansGetBenefitPlanGroupResponses, BenefitPlansGetBenefitPlanGroupErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        headers: zBenefitPlansGetBenefitPlanGroupHeaders.optional(),
        path: zBenefitPlansGetBenefitPlanGroupPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) => await zBenefitPlansGetBenefitPlanGroupResponse.parseAsync(data),
    url: '/benefit-plan-groups/{id}',
    ...options
});

/**
 * Update a benefit plan group
 *
 * Updates mutable properties of a group. Changing `size` triggers a
 * resize — plans are added or removed to match the new option count.
 * Send `expectedSize` with it to make the resize conditional on the
 * size you read; a stale value is refused with 409.
 *
 */
export const benefitPlansUpdateBenefitPlanGroup = <ThrowOnError extends boolean = false>(options: Options<BenefitPlansUpdateBenefitPlanGroupData, ThrowOnError>): RequestResult<BenefitPlansUpdateBenefitPlanGroupResponses, BenefitPlansUpdateBenefitPlanGroupErrors, ThrowOnError> => (options.client ?? client).patch<BenefitPlansUpdateBenefitPlanGroupResponses, BenefitPlansUpdateBenefitPlanGroupErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: zBenefitPlansUpdateBenefitPlanGroupBody,
        headers: zBenefitPlansUpdateBenefitPlanGroupHeaders.optional(),
        path: zBenefitPlansUpdateBenefitPlanGroupPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) => await zBenefitPlansUpdateBenefitPlanGroupResponse.parseAsync(data),
    url: '/benefit-plan-groups/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get a benefit plan group's premiums
 *
 * Returns only the on-demand premium rollups for a group (group totals
 * plus per-plan premiums). Lets the rates summary refresh premiums after
 * an inline rate edit without refetching the full group payload, which
 * would remount the editable rates grid. Premiums are computed from the
 * rates and never persisted.
 *
 */
export const benefitPlansGetBenefitPlanGroupPremiums = <ThrowOnError extends boolean = false>(options: Options<BenefitPlansGetBenefitPlanGroupPremiumsData, ThrowOnError>): RequestResult<BenefitPlansGetBenefitPlanGroupPremiumsResponses, BenefitPlansGetBenefitPlanGroupPremiumsErrors, ThrowOnError> => (options.client ?? client).get<BenefitPlansGetBenefitPlanGroupPremiumsResponses, BenefitPlansGetBenefitPlanGroupPremiumsErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zBenefitPlansGetBenefitPlanGroupPremiumsPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) => await zBenefitPlansGetBenefitPlanGroupPremiumsResponse.parseAsync(data),
    url: '/benefit-plan-groups/{id}/premiums',
    ...options
});

/**
 * Reorder benefit plan groups
 *
 * Sets the display order of groups for a given RFP, coverage type, and
 * product type. All group IDs for that combination must be included.
 *
 */
export const benefitPlansReorderBenefitPlanGroups = <ThrowOnError extends boolean = false>(options: Options<BenefitPlansReorderBenefitPlanGroupsData, ThrowOnError>): RequestResult<BenefitPlansReorderBenefitPlanGroupsResponses, BenefitPlansReorderBenefitPlanGroupsErrors, ThrowOnError> => (options.client ?? client).patch<BenefitPlansReorderBenefitPlanGroupsResponses, BenefitPlansReorderBenefitPlanGroupsErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: zBenefitPlansReorderBenefitPlanGroupsBody,
        path: z.never().optional(),
        query: zBenefitPlansReorderBenefitPlanGroupsQuery
    }).parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) => await zBenefitPlansReorderBenefitPlanGroupsResponse.parseAsync(data),
    url: '/benefit-plan-groups/reorder',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Upsert a benefit plan
 *
 * Creates or updates a single benefit plan on an RFP using a
 * composite key match.
 *
 * **Matching:** The plan is matched to an existing record using:
 * - `coverageType` (dental, std, vision, …)
 * - `type` (ppo, notApplicable, …)
 * - `policyPeriod` (current, …)
 * - `optionName` (high, low, notApplicable)
 *
 * If a match is found, the plan is updated (only provided fields
 * are changed). If no match is found, a new coverage, group, and
 * plan are created.
 *
 * The operation is idempotent — sending the same payload twice
 * produces the same result.
 *
 */
export const benefitPlansUpsertBenefitPlan = <ThrowOnError extends boolean = false>(options: Options<BenefitPlansUpsertBenefitPlanData, ThrowOnError>): RequestResult<BenefitPlansUpsertBenefitPlanResponses, BenefitPlansUpsertBenefitPlanErrors, ThrowOnError> => (options.client ?? client).put<BenefitPlansUpsertBenefitPlanResponses, BenefitPlansUpsertBenefitPlanErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: zBenefitPlansUpsertBenefitPlanBody,
        path: zBenefitPlansUpsertBenefitPlanPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) => await zBenefitPlansUpsertBenefitPlanResponse.parseAsync(data),
    url: '/rfps/{rfpId}/benefit-plans/upsert',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update a benefit plan
 *
 * Partially updates a single benefit plan. Only provided fields are
 * changed. The plan `type` is immutable after initial creation.
 *
 * The `benefits` field is polymorphic — its shape depends on the
 * coverage type (dental, vision, medical, etc.).
 *
 * Setting `eligibilityClasses` to an empty array clears all class
 * assignments; omitting the field leaves them unchanged.
 *
 * A field of `benefits` sent as null is left as it is. To empty one,
 * name it in `clearBenefitFields`, with `benefits` (whose `objectType`
 * says which benefit); a name that is not a nullable field of that
 * benefit is a 400 naming it, and nothing is saved.
 *
 */
export const benefitPlansUpdateBenefitPlan = <ThrowOnError extends boolean = false>(options: Options<BenefitPlansUpdateBenefitPlanData, ThrowOnError>): RequestResult<BenefitPlansUpdateBenefitPlanResponses, BenefitPlansUpdateBenefitPlanErrors, ThrowOnError> => (options.client ?? client).patch<BenefitPlansUpdateBenefitPlanResponses, BenefitPlansUpdateBenefitPlanErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: zBenefitPlansUpdateBenefitPlanBody,
        headers: zBenefitPlansUpdateBenefitPlanHeaders.optional(),
        path: zBenefitPlansUpdateBenefitPlanPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zBenefitPlansUpdateBenefitPlanResponse.parseAsync(data),
    url: '/benefit-plans/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List proposals for an RFP
 *
 * Returns the deliverable proposals for a given RFP by default — the
 * active version of each carrier lane (`is_active_version = true`), i.e.
 * what reaches the marketing presentation.
 *
 * Pass `scope` to select a different read scope (ADR-031):
 * - `scope=board` — active versions plus un-actioned pending requotes (the
 * SBS board, including the pending requote column).
 * - `scope=all` — every version: active, pending, and actioned historical
 * (the SBS Quote History full-history view).
 *
 * Returns an empty array `[]` (not an error) when no proposals
 * exist for the RFP.
 *
 * Without `include=coverages`, returns summary-level data only.
 * With `include=coverages`, returns full detail including coverages,
 * plan groups, plans, and rate schedules, with the enrollment flags and
 * the Current plan's figures that compare each carrier quote with the
 * Current plan. If the Current plan cannot be read, the quotes are returned
 * without the flags.
 *
 */
export const proposalsListProposalsForRfp = <ThrowOnError extends boolean = false>(options: Options<ProposalsListProposalsForRfpData, ThrowOnError>): RequestResult<ProposalsListProposalsForRfpResponses, ProposalsListProposalsForRfpErrors, ThrowOnError> => (options.client ?? client).get<ProposalsListProposalsForRfpResponses, ProposalsListProposalsForRfpErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        headers: zProposalsListProposalsForRfpHeaders.optional(),
        path: zProposalsListProposalsForRfpPath,
        query: zProposalsListProposalsForRfpQuery.optional()
    }).parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) => await zProposalsListProposalsForRfpResponse.parseAsync(data),
    url: '/rfps/{id}/proposals',
    ...options
});

/**
 * Create an analyst proposal (materialize a placeholder)
 *
 * Creates an analyst-authored proposal (`origin = analyst`) for a carrier
 * under an RFP. Only `origin = analyst` is accepted — carrier proposals are
 * created by ingestion, never via this endpoint.
 *
 * When a `materialize` block is supplied, the endpoint atomically turns a
 * synthesized "awaiting quote" placeholder column into a real proposal plan
 * group: it find-or-creates the active analyst proposal for the carrier, adds
 * the plan group shaped from the referenced RFP benefit plan group, and
 * applies the single edited benefit — all in one transaction (ADR-024). The
 * carrier's synthesized placeholder for that coverage is then suppressed on
 * read in favor of this real analyst column.
 *
 * Requires an internal role (admin, analyst, or consultant).
 *
 */
export const proposalsCreateProposalForRfp = <ThrowOnError extends boolean = false>(options: Options<ProposalsCreateProposalForRfpData, ThrowOnError>): RequestResult<ProposalsCreateProposalForRfpResponses, ProposalsCreateProposalForRfpErrors, ThrowOnError> => (options.client ?? client).post<ProposalsCreateProposalForRfpResponses, ProposalsCreateProposalForRfpErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: zProposalsCreateProposalForRfpBody,
        headers: zProposalsCreateProposalForRfpHeaders.optional(),
        path: zProposalsCreateProposalForRfpPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) => await zProposalsCreateProposalForRfpResponse.parseAsync(data),
    url: '/rfps/{id}/proposals',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get a proposal
 *
 * Returns a single proposal with the full nested entity tree
 * eagerly loaded: proposal → coverages → plan groups → plans
 * (with benefits).
 *
 * Plan `identifier` values (e.g., `DEN-1-1`, `VIS-2-3`) are
 * computed at response time and not stored. Benefits are returned
 * in the canonical v5 shape with internal persistence fields
 * (`id`, `createdAt`, `updatedAt`) stripped from domain wrappers.
 *
 * For dental benefits, `serviceWaitingPeriods` is always included
 * in the response (never omitted), even when the array is empty.
 *
 */
export const proposalsGetProposal = <ThrowOnError extends boolean = false>(options: Options<ProposalsGetProposalData, ThrowOnError>): RequestResult<ProposalsGetProposalResponses, ProposalsGetProposalErrors, ThrowOnError> => (options.client ?? client).get<ProposalsGetProposalResponses, ProposalsGetProposalErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        headers: zProposalsGetProposalHeaders.optional(),
        path: zProposalsGetProposalPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) => await zProposalsGetProposalResponse.parseAsync(data),
    url: '/proposals/{id}',
    ...options
});

/**
 * Update proposal plan benefits
 *
 * Replaces the benefit data for a single carrier proposal plan.
 *
 * The `benefits` blob must be in the canonical v5 shape for the plan's
 * coverage type (dental, vision, accident, cancer, criticalIllness, or
 * hospitalIndemnity). The coverage type is resolved server-side from the
 * plan record — callers do not need to supply it.
 *
 * Requires an internal role (admin, analyst, or consultant).
 *
 */
export const proposalsUpdateProposalPlanBenefits = <ThrowOnError extends boolean = false>(options: Options<ProposalsUpdateProposalPlanBenefitsData, ThrowOnError>): RequestResult<ProposalsUpdateProposalPlanBenefitsResponses, ProposalsUpdateProposalPlanBenefitsErrors, ThrowOnError> => (options.client ?? client).patch<ProposalsUpdateProposalPlanBenefitsResponses, ProposalsUpdateProposalPlanBenefitsErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: zProposalsUpdateProposalPlanBenefitsBody,
        path: zProposalsUpdateProposalPlanBenefitsPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zProposalsUpdateProposalPlanBenefitsResponse.parseAsync(data),
    url: '/proposal-plans/{id}/benefits',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a single proposal plan
 *
 * Soft-deletes a single carrier proposal plan (CD-89 AC1).
 *
 * Deleting is permitted only when the plan's group is the active version
 * of the RFP-requested plan it answers; a pending requote or an actioned
 * historical quote is read-only in Quote History and the request returns
 * 400 (ADR-031, CD-1792 follow-up). Two carve-outs are exempt from that
 * check regardless of the owning proposal's version state: a duplicate an
 * analyst authored (`origin = analyst`, not carrier quote history), and an
 * unmapped group (no `rfpBenefitPlanGroupId`), which answers no requested
 * plan and so has no version of its own to protect.
 *
 * The version check applies only while the `ppx-quote-history` feature
 * flag evaluates on. When an initialized flag client evaluates it off or
 * undefined (GrowthBook omits a feature whose environment toggle is off),
 * every version a carrier returned is an ordinary board column and any of
 * them may be deleted (CD-1730, CD-3010). A missing flag client keeps the
 * check in place.
 *
 * Deleting a plan also marks its group `padSuppressed`, so the slot is not
 * padded back as an empty "Not received" column when the group now quotes
 * fewer plans than its RFP baseline (CD-3010). Restoring the plan leaves
 * `padSuppressed` set.
 *
 * Requires an internal role (admin, analyst, or consultant).
 *
 */
export const proposalsDeleteProposalPlan = <ThrowOnError extends boolean = false>(options: Options<ProposalsDeleteProposalPlanData, ThrowOnError>): RequestResult<ProposalsDeleteProposalPlanResponses, ProposalsDeleteProposalPlanErrors, ThrowOnError> => (options.client ?? client).delete<ProposalsDeleteProposalPlanResponses, ProposalsDeleteProposalPlanErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zProposalsDeleteProposalPlanPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zProposalsDeleteProposalPlanResponse.parseAsync(data),
    url: '/proposal-plans/{id}',
    ...options
});

/**
 * Update proposal plan fields
 *
 * Updates plan-level attributes (plan name, funding type, participation
 * requirements, rate guarantee, rate cap, Critical Illness rider charges)
 * for a single carrier proposal plan. All fields
 * are optional; omitted fields are left unchanged. Benefit values are updated
 * separately via PATCH /proposal-plans/{id}/benefits.
 *
 * When `optionName` changes, the plan's enrolled lives and volumes are re-copied from the
 * RFP's Current plan carrying the new label, by the same rules as ingest. Only the
 * relabelled plan is written, so correcting an inverted Low/High takes one call per plan,
 * in either order. The re-copy replaces enrollment on every schedule it covers, including
 * a manual edit there; schedules it does not cover, plans in a group the copy does not
 * apply to (no Current plan, several Current groups, or no Current plan with that label),
 * and plans whose group's analyst chose the carrier's figures (see
 * `PATCH /proposal-plan-groups/{id}`), keep their figures.
 *
 * Requires an internal role (admin, analyst, or consultant).
 *
 */
export const proposalsUpdateProposalPlanFields = <ThrowOnError extends boolean = false>(options: Options<ProposalsUpdateProposalPlanFieldsData, ThrowOnError>): RequestResult<ProposalsUpdateProposalPlanFieldsResponses, ProposalsUpdateProposalPlanFieldsErrors, ThrowOnError> => (options.client ?? client).patch<ProposalsUpdateProposalPlanFieldsResponses, ProposalsUpdateProposalPlanFieldsErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: zProposalsUpdateProposalPlanFieldsBody,
        path: zProposalsUpdateProposalPlanFieldsPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zProposalsUpdateProposalPlanFieldsResponse.parseAsync(data),
    url: '/proposal-plans/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Restore a deleted proposal plan
 *
 * Undoes a soft-delete of a single carrier proposal plan — the "Undo"
 * action offered after Delete Plan.
 *
 * Subject to the same version-state guard as delete: the request returns
 * 400 when the plan's group is a non-active, mapped proposal version. An
 * unmapped group, or a duplicate an analyst authored, is exempt from that
 * check regardless of the owning proposal's version state, and the check
 * applies only while `ppx-quote-history` evaluates on (same carve-outs and
 * flag behavior as DELETE /proposal-plans/{id}). Restoring does not clear
 * the group's `padSuppressed` set by the delete.
 *
 * Requires an internal role (admin, analyst, or consultant).
 *
 */
export const proposalsRestoreProposalPlan = <ThrowOnError extends boolean = false>(options: Options<ProposalsRestoreProposalPlanData, ThrowOnError>): RequestResult<ProposalsRestoreProposalPlanResponses, ProposalsRestoreProposalPlanErrors, ThrowOnError> => (options.client ?? client).post<ProposalsRestoreProposalPlanResponses, ProposalsRestoreProposalPlanErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zProposalsRestoreProposalPlanPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zProposalsRestoreProposalPlanResponse.parseAsync(data),
    url: '/proposal-plans/{id}/restore',
    ...options
});

/**
 * Delete a proposal plan group
 *
 * Soft-deletes a proposal plan group from the SBS page (CD-89 AC1).
 *
 * Deleting is permitted only when the group is the active version of the
 * RFP-requested plan it answers; a pending requote or an actioned
 * historical quote is read-only in Quote History and the request returns
 * 400 (ADR-031, CD-1792 follow-up). Two carve-outs are exempt from that
 * check regardless of the owning proposal's version state: a duplicate an
 * analyst authored (`origin = analyst`, not carrier quote history), and an
 * unmapped group (no `rfpBenefitPlanGroupId`), which answers no requested
 * plan and so has no version of its own to protect.
 *
 * The version check applies only while the `ppx-quote-history` feature
 * flag evaluates on. When an initialized flag client evaluates it off or
 * undefined (GrowthBook omits a feature whose environment toggle is off),
 * every version a carrier returned is an ordinary board column and any of
 * them may be deleted (CD-1730, CD-3010). A missing flag client keeps the
 * check in place.
 *
 */
export const proposalsDeleteProposalPlanGroup = <ThrowOnError extends boolean = false>(options: Options<ProposalsDeleteProposalPlanGroupData, ThrowOnError>): RequestResult<ProposalsDeleteProposalPlanGroupResponses, ProposalsDeleteProposalPlanGroupErrors, ThrowOnError> => (options.client ?? client).delete<ProposalsDeleteProposalPlanGroupResponses, ProposalsDeleteProposalPlanGroupErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zProposalsDeleteProposalPlanGroupPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zProposalsDeleteProposalPlanGroupResponse.parseAsync(data),
    url: '/proposal-plan-groups/{id}',
    ...options
});

/**
 * Update proposal plan group fields
 *
 * Updates group-level fields for a single carrier proposal plan group.
 * All fields are optional; omitted fields are left unchanged. Sending an
 * empty `footnote` clears it.
 *
 * `enrollmentDecision` records the analyst's choice between the Current plan's enrollment
 * and the enrollment the carrier quoted. The Quotes grid offers one choice for all of a
 * group's options, so it is recorded on every plan of the group, with the analyst who
 * chose and the time. `kept_current` records the choice and leaves the quote's enrollment
 * as it is. `used_carrier` also puts the carrier's lives and volume back on the quote's
 * rates, where the carrier quoted one; the stored carrier figures stay. Neither changes
 * the Current plan. A plan the carrier quoted no enrollment for is not decided, since it
 * has no carrier figures to compare or restore.
 *
 * A choice can be changed. Choosing `kept_current` after `used_carrier` puts the Current
 * plan's lives and volume back on the quote, paired by each plan's label as it then stands.
 * Relabelling a plan through `PATCH /proposal-plans/{id}` leaves the carrier's figures in
 * place once `used_carrier` was chosen.
 *
 * A decision is accepted for any group the carrier quoted enrollment for, whether or not
 * it differs from Current. `enrollmentNeedsDecision` only says whether a flagged group
 * still awaits one. For a group the carrier quoted no enrollment for, the request returns
 * 400 and nothing is stored. A value other than `kept_current` or `used_carrier` also
 * returns 400.
 *
 * The request is saved as a whole or not at all: if the decision cannot be recorded, the
 * other fields sent with it, such as `footnote`, are not saved either.
 *
 * Requires an internal role (admin, analyst, or consultant).
 *
 */
export const proposalsUpdateProposalPlanGroupFields = <ThrowOnError extends boolean = false>(options: Options<ProposalsUpdateProposalPlanGroupFieldsData, ThrowOnError>): RequestResult<ProposalsUpdateProposalPlanGroupFieldsResponses, ProposalsUpdateProposalPlanGroupFieldsErrors, ThrowOnError> => (options.client ?? client).patch<ProposalsUpdateProposalPlanGroupFieldsResponses, ProposalsUpdateProposalPlanGroupFieldsErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: zProposalsUpdateProposalPlanGroupFieldsBody,
        path: zProposalsUpdateProposalPlanGroupFieldsPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) => await zProposalsUpdateProposalPlanGroupFieldsResponse.parseAsync(data),
    url: '/proposal-plan-groups/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Replace the active quote with a pending requote
 *
 * Promotes a pending requote to the active version of the RFP-requested plan
 * it answers and demotes the prior active quote for that requested plan (which
 * moves to Quote History). Scoped per (rfp, carrier, requested plan) — the same
 * grain as `carrierQuoteVersion` — so replacing one requested plan's quote never
 * affects another requested plan sharing the same proposal (ADR-031, CD-1792
 * follow-up). The target must be a pending requote (`requoteReviewState =
 * pending`); otherwise 400. Sets `requoteReviewState = actioned` on the
 * promoted group.
 *
 */
export const proposalsReplaceProposalPlanGroup = <ThrowOnError extends boolean = false>(options: Options<ProposalsReplaceProposalPlanGroupData, ThrowOnError>): RequestResult<ProposalsReplaceProposalPlanGroupResponses, ProposalsReplaceProposalPlanGroupErrors, ThrowOnError> => (options.client ?? client).post<ProposalsReplaceProposalPlanGroupResponses, ProposalsReplaceProposalPlanGroupErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        headers: zProposalsReplaceProposalPlanGroupHeaders.optional(),
        path: zProposalsReplaceProposalPlanGroupPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) => await zProposalsReplaceProposalPlanGroupResponse.parseAsync(data),
    url: '/proposal-plan-groups/{id}/replace',
    ...options
});

/**
 * Disregard a pending requote
 *
 * Resolves a pending requote without promoting it: `requoteReviewState`
 * becomes `actioned` and `isActiveVersion` stays false, so the requote drops
 * off the SBS board into Quote History and the requested plan's prior active
 * quote is left in place. Scoped per (rfp, carrier, requested plan) (ADR-031,
 * CD-1792 follow-up). The target must be a pending requote; otherwise 400.
 *
 */
export const proposalsDisregardProposalPlanGroup = <ThrowOnError extends boolean = false>(options: Options<ProposalsDisregardProposalPlanGroupData, ThrowOnError>): RequestResult<ProposalsDisregardProposalPlanGroupResponses, ProposalsDisregardProposalPlanGroupErrors, ThrowOnError> => (options.client ?? client).post<ProposalsDisregardProposalPlanGroupResponses, ProposalsDisregardProposalPlanGroupErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        headers: zProposalsDisregardProposalPlanGroupHeaders.optional(),
        path: zProposalsDisregardProposalPlanGroupPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) => await zProposalsDisregardProposalPlanGroupResponse.parseAsync(data),
    url: '/proposal-plan-groups/{id}/disregard',
    ...options
});

/**
 * Promote a historical quote to active
 *
 * Re-promotes a superseded (historical) quote to the active version of the
 * RFP-requested plan it answers, demoting whatever is currently active for
 * that requested plan (which moves to Quote History). Scoped per (rfp,
 * carrier, requested plan) (ADR-031, CD-1792 follow-up). The target must be an
 * actioned, inactive quote (`isActiveVersion = false`, `requoteReviewState =
 * actioned`); otherwise 400. Restoring an older version over a newer one is
 * permitted — `isActiveVersion` is the analyst-chosen "current shown version".
 *
 */
export const proposalsPromoteProposalPlanGroup = <ThrowOnError extends boolean = false>(options: Options<ProposalsPromoteProposalPlanGroupData, ThrowOnError>): RequestResult<ProposalsPromoteProposalPlanGroupResponses, ProposalsPromoteProposalPlanGroupErrors, ThrowOnError> => (options.client ?? client).post<ProposalsPromoteProposalPlanGroupResponses, ProposalsPromoteProposalPlanGroupErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        headers: zProposalsPromoteProposalPlanGroupHeaders.optional(),
        path: zProposalsPromoteProposalPlanGroupPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) => await zProposalsPromoteProposalPlanGroupResponse.parseAsync(data),
    url: '/proposal-plan-groups/{id}/promote',
    ...options
});

/**
 * Restore a deleted quote
 *
 * Clears the deletion on a quote the analyst deleted, bringing it back out of
 * Quote History (CD-89 AC1). The group and the plans deleted with it are
 * restored together.
 *
 * Never promotes. Deleting is permitted only on the active version, so a quote
 * deleted while active returns to the board; one that a Replace superseded while
 * it sat deleted returns to Quote History instead. The response body carries the
 * resolved state so the caller can say which happened.
 *
 * Idempotent: restoring a quote that is not deleted is a no-op, not an error.
 *
 */
export const proposalsRestoreProposalPlanGroup = <ThrowOnError extends boolean = false>(options: Options<ProposalsRestoreProposalPlanGroupData, ThrowOnError>): RequestResult<ProposalsRestoreProposalPlanGroupResponses, ProposalsRestoreProposalPlanGroupErrors, ThrowOnError> => (options.client ?? client).post<ProposalsRestoreProposalPlanGroupResponses, ProposalsRestoreProposalPlanGroupErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        headers: zProposalsRestoreProposalPlanGroupHeaders.optional(),
        path: zProposalsRestoreProposalPlanGroupPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) => await zProposalsRestoreProposalPlanGroupResponse.parseAsync(data),
    url: '/proposal-plan-groups/{id}/restore',
    ...options
});

/**
 * Add a plan to an existing proposal plan group
 *
 * Creates a real plan inside an existing quoted proposal plan group at the
 * given 1-based position — an analyst filling an under-quoted group's
 * empty pad slot (partial fill). The group's `size` grows to cover the new
 * plan when needed. `benefits` is optional: omitting it creates a bare
 * plan of the coverage's type for the analyst to fill in afterwards.
 *
 * Requires an internal role (admin, analyst, or consultant).
 *
 */
export const proposalsAddProposalPlanToGroup = <ThrowOnError extends boolean = false>(options: Options<ProposalsAddProposalPlanToGroupData, ThrowOnError>): RequestResult<ProposalsAddProposalPlanToGroupResponses, ProposalsAddProposalPlanToGroupErrors, ThrowOnError> => (options.client ?? client).post<ProposalsAddProposalPlanToGroupResponses, ProposalsAddProposalPlanToGroupErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: zProposalsAddProposalPlanToGroupBody,
        path: zProposalsAddProposalPlanToGroupPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) => await zProposalsAddProposalPlanToGroupResponse.parseAsync(data),
    url: '/proposal-plan-groups/{id}/plans',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a proposal commission
 *
 * Deletes the carrier's returned commission for a single proposal
 * plan.
 *
 * Requires write access to the RFP.
 *
 */
export const proposalsDeleteProposalCommission = <ThrowOnError extends boolean = false>(options: Options<ProposalsDeleteProposalCommissionData, ThrowOnError>): RequestResult<ProposalsDeleteProposalCommissionResponses, ProposalsDeleteProposalCommissionErrors, ThrowOnError> => (options.client ?? client).delete<ProposalsDeleteProposalCommissionResponses, ProposalsDeleteProposalCommissionErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zProposalsDeleteProposalCommissionPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zProposalsDeleteProposalCommissionResponse.parseAsync(data),
    url: '/rfps/{id}/proposals/{proposalId}/commissions/{proposalPlanId}',
    ...options
});

/**
 * Upsert a proposal commission
 *
 * Creates or updates the carrier's returned commission for a single
 * proposal plan. Scoped to a proposal plan (not a coverage), so
 * proposals with multiple plans per coverage have independent
 * commission rows.
 *
 * When `returnedType` is `notDisclosed`, `returnedAmount` and
 * `returnedHeapedAmount` must both be omitted. When `returnedType` is
 * `heaped`, `returnedAmount` must be omitted (`returnedHeapedAmount`
 * carries the value instead). For all other types,
 * `returnedHeapedAmount` must be omitted.
 *
 * Requires write access to the RFP.
 *
 */
export const proposalsUpdateProposalCommission = <ThrowOnError extends boolean = false>(options: Options<ProposalsUpdateProposalCommissionData, ThrowOnError>): RequestResult<ProposalsUpdateProposalCommissionResponses, ProposalsUpdateProposalCommissionErrors, ThrowOnError> => (options.client ?? client).patch<ProposalsUpdateProposalCommissionResponses, ProposalsUpdateProposalCommissionErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: zProposalsUpdateProposalCommissionBody,
        path: zProposalsUpdateProposalCommissionPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zProposalsUpdateProposalCommissionResponse.parseAsync(data),
    url: '/rfps/{id}/proposals/{proposalId}/commissions/{proposalPlanId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get an RFP
 *
 * Returns the full RFP structure including all coverages, benefit
 * plan groups, benefit plans, and broker commissions.
 *
 * If the RFP does not yet exist in BTX, it is initialized from the
 * broker portal configuration. New Business plans are pre-filled
 * from a matching Centro Benchmark plan design when one exists;
 * other plans start empty.
 *
 * If the RFP already exists, each call first reconciles its
 * coverages with the broker portal, and the response reflects the
 * reconciled state. When a coverage has moved from New Business to
 * Current, each of its benchmark-filled plans is resolved one of
 * two ways:
 *
 * - If the plan has been changed since it was filled (edited plan
 * fields, rates, or eligibility classes), it is kept as is, with
 * the same ID, and marked Current.
 * - Otherwise it is replaced by an empty Current plan with a new
 * ID. The replaced plan is soft-deleted with its benefit data
 * kept, and no longer appears in the response.
 *
 * This is the primary read endpoint for AI integrations that need
 * to discover the plan structure (UUIDs, identifiers, coverage
 * types) before issuing batch updates.
 *
 */
export const rfpsGetRfp = <ThrowOnError extends boolean = false>(options: Options<RfpsGetRfpData, ThrowOnError>): RequestResult<RfpsGetRfpResponses, RfpsGetRfpErrors, ThrowOnError> => (options.client ?? client).get<RfpsGetRfpResponses, RfpsGetRfpErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        headers: zRfpsGetRfpHeaders.optional(),
        path: zRfpsGetRfpPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) => await zRfpsGetRfpResponse.parseAsync(data),
    url: '/rfps/{id}',
    ...options
});

/**
 * Export an RFP's v5 payload
 *
 * Returns the v5 payload a submission of the RFP would send carriers,
 * built exactly as `POST /rfps/{id}/submit` builds it, with every
 * coverage, but neither checked for submission (the census-to-class
 * check included) nor sent. Nothing is recorded: no RFP version,
 * submission, or proposal. The payload is always in the current spec
 * version; an `X-RFP-Spec-Version` request header is ignored, and the
 * response header names the version.
 *
 * The golden-set tool uses it to score what RUMI built on a replay RFP
 * against an analyst's submission, which carrier-rfpq stores in the
 * same shape.
 *
 */
export const rfpsExportRfpPayload = <ThrowOnError extends boolean = false>(options: Options<RfpsExportRfpPayloadData, ThrowOnError>): RequestResult<RfpsExportRfpPayloadResponses, RfpsExportRfpPayloadErrors, ThrowOnError> => (options.client ?? client).get<RfpsExportRfpPayloadResponses, RfpsExportRfpPayloadErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zRfpsExportRfpPayloadPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) => await zRfpsExportRfpPayloadResponse.parseAsync(data),
    url: '/rfps/{id}/v5-payload',
    ...options
});

/**
 * Set coverage completion status
 *
 * Marks a coverage (line of coverage) as complete or incomplete
 * for a given RFP.
 *
 * **Marking complete** triggers server-side validation:
 * - The coverage must have at least one benefit plan group.
 * - At least one eligibility class must be assigned.
 * - All required benefit plan fields must be populated.
 * - All benefit plan group validations must pass.
 *
 * If validation fails, a `400` response is returned with an
 * array of validation errors. The coverage is **not** marked
 * complete.
 *
 * **Marking incomplete** skips validation and always succeeds.
 *
 * For coverages with multiple product types (e.g., Dental PPO
 * and Dental HMO), the `productType` query parameter is
 * required to target a specific product type.
 *
 */
export const rfpsSetCoverageCompletion = <ThrowOnError extends boolean = false>(options: Options<RfpsSetCoverageCompletionData, ThrowOnError>): RequestResult<RfpsSetCoverageCompletionResponses, RfpsSetCoverageCompletionErrors, ThrowOnError> => (options.client ?? client).post<RfpsSetCoverageCompletionResponses, RfpsSetCoverageCompletionErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: zRfpsSetCoverageCompletionBody,
        path: zRfpsSetCoverageCompletionPath,
        query: zRfpsSetCoverageCompletionQuery.optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zRfpsSetCoverageCompletionResponse.parseAsync(data),
    url: '/rfps/{id}/coverages/{coverageType}/completion',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List carriers with saved notes
 *
 * Returns the IDs of carriers that have saved (non-deleted) notes
 * for an RFP, without loading note content. Useful for seeding UI
 * state to know which carriers have notes before individual loads.
 *
 */
export const rfpsListCarrierNoteExistence = <ThrowOnError extends boolean = false>(options: Options<RfpsListCarrierNoteExistenceData, ThrowOnError>): RequestResult<RfpsListCarrierNoteExistenceResponses, RfpsListCarrierNoteExistenceErrors, ThrowOnError> => (options.client ?? client).get<RfpsListCarrierNoteExistenceResponses, RfpsListCarrierNoteExistenceErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zRfpsListCarrierNoteExistencePath,
        query: z.never().optional()
    }).parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) => await zRfpsListCarrierNoteExistenceResponse.parseAsync(data),
    url: '/rfps/{id}/notes',
    ...options
});

/**
 * Upsert field comments across benefit plans
 *
 * Writes field-level comment state on any number of fields, across
 * any number of benefit plans of one RFP, in one transaction.
 *
 * Each field is matched on its benefit plan and `fieldPath`:
 * - A field with no comment gets one. Omitted values take their
 * defaults, and `needsReview` defaults to `true`, so send it
 * explicitly when the field should stay out of review. A field
 * that only sets `manuallyEdited: true`, with no comment text,
 * defaults to `false` instead: the edited mark alone doesn't put
 * a field in review.
 * - A field with a comment is updated. Omitted values are left
 * unchanged; an empty string clears `comment` or
 * `aiOriginalValue`.
 * - A field whose comment was deleted has it restored as if it
 * were new: values the request omits take their defaults rather
 * than the deleted comment's.
 *
 * Every benefit plan must belong to the RFP in the path. If any
 * does not, or if any field fails validation, nothing is written.
 *
 */
export const rfpsUpsertFieldComments = <ThrowOnError extends boolean = false>(options: Options<RfpsUpsertFieldCommentsData, ThrowOnError>): RequestResult<RfpsUpsertFieldCommentsResponses, RfpsUpsertFieldCommentsErrors, ThrowOnError> => (options.client ?? client).patch<RfpsUpsertFieldCommentsResponses, RfpsUpsertFieldCommentsErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: zRfpsUpsertFieldCommentsBody,
        path: zRfpsUpsertFieldCommentsPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) => await zRfpsUpsertFieldCommentsResponse2.parseAsync(data),
    url: '/rfps/{id}/field-comments',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
